export default {
  title: 'setting',
  type: 'object',
  properties: {
    code: {
      title: 'Kod ustawienia',
      type: 'string',
      fieldRequired: true,
      maxLength: 500
    },
    groupId: {
      title: 'Grupa ustawienia',
      type: 'number'
    },
    description: {
      title: 'Opis ustawienia',
      type: 'string',
      fieldRequired: false,
      maxLength: 500
    },
    entityType: {
      title: 'Typ powiązanej encji',
      type: 'string',
      fieldRequired: false
    },
    entityId: {
      title: 'Identyfikator powiązanej encji',
      type: 'string',
      fieldRequired: false
    },
    value: {
      title: 'Wartość ustawienia',
      type: 'string',
      fieldRequired: false
    },
    valueType: {
      title: 'Typ wartości',
      type: 'string',
      fieldRequired: true
    }
  }
};
